export default "__VITE_ASSET__5XKIQkSp__"